export function camelToSnakeCase(str: string): string {
  return str.replace(/[A-Z]/g, function (match, index) {
    return index === 0 ? match.toLowerCase() : "_" + match.toLowerCase();
  });
}
